import { c as _c } from "react/compiler-runtime";
import { SideSheet } from "@opensea/ui-kit";
import { SyncAlt } from "@opensea/ui-kit/icons";
import { useState } from "react";
import { SwapFlow } from "../../flow/SideSheetFlows/SwapFlow";
import { Button } from "../Button";
export function InlineSwapButton(t0) {
  const $ = _c(14);
  const {
    onBack,
    onClose,
    initialFromCurrency,
    initialToCurrency
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== onBack) {
    t1 = () => {
      setOpen(false);
      onBack?.();
    };
    $[0] = onBack;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose) {
    t2 = () => {
      setOpen(false);
      onClose?.();
    };
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== initialFromCurrency || $[5] !== initialToCurrency || $[6] !== t1 || $[7] !== t2) {
    t3 = <SwapFlow initialFromCurrency={initialFromCurrency} initialToCurrency={initialToCurrency} onBack={t1} onClose={t2} />;
    $[4] = initialFromCurrency;
    $[5] = initialToCurrency;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      Overlay: {}
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Button icon={SyncAlt} onClick={() => setOpen(true)} size="sm" variant="secondary" />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== open || $[12] !== t3) {
    t6 = <SideSheet content={t3} direction="right" nested={true} onOpenChange={setOpen} open={open} overrides={t4}>{t5}</SideSheet>;
    $[11] = open;
    $[12] = t3;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}